import DrillDownInteraction from './drillDown';
export var INTERACTION_MAP = {
    drilldown: DrillDownInteraction,
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/plots/treemap/interaction/index.js
// module id = null
// module chunks = 